// angular
import { NgClass } from '@angular/common';
import { Component, effect, inject, input } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// components
import { InputComponent } from '@app/core/components/input/input.component';
import { AdvancedFiltersComponent } from '@app/layout/components/advanced-filters/advanced-filters.component';
// services
import { ProductsService } from '@app/+products/shared/services/products.service';
import { ElasticSearchService } from '@app/+search/shared/services/elastic-search.service';
import { DialogService } from '@app/core/shared/services/dialog.service';
import { LayoutService } from '@app/layout/shared/services/layout.service';

@Component({
  selector: 'pwj-home-search-section',
  standalone: true,
  imports: [
    InputComponent,
    TranslateModule,
    NgClass,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './home-search-section.component.html',
  styleUrl: './home-search-section.component.scss',
  providers: [ElasticSearchService],
})
export class HomeSearchSectionComponent {
  public hiddenAdvancedFilters!: boolean;
  // form property
  public searchForm!: FormGroup;

  // inputs
  wFull = input<boolean>(false);

  // dependencies
  private readonly _layoutService = inject(LayoutService);
  private readonly _dialogService = inject(DialogService);
  private readonly _fb = inject(FormBuilder);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _productsService = inject(ProductsService);
  private readonly _elasticSearchService = inject(ElasticSearchService);

  constructor() {
    // initialize search form
    this.searchForm = this._fb.group({
      searchTerm: '',
    });

    effect(() => {
      this.hiddenAdvancedFilters = this._layoutService.hiddenAdvancedFilters();
    });

    // update search field value if search term is exist
    this._activatedRoute.queryParams.subscribe(params => {
      const searchTerm = params?.['search'];

      if (searchTerm) {
        this.searchForm.patchValue({
          searchTerm,
        });
      }
    });
  }

  public toggleAdvancedFilters() {
    this._layoutService.hiddenAdvancedFilters.set(!this.hiddenAdvancedFilters);

    const dialogRef = this._dialogService.open(AdvancedFiltersComponent, {
      width: '72em',
      height: 'none',
    });

    dialogRef.afterClosed().subscribe(res => {
      this._layoutService.hiddenAdvancedFilters.set(true);
    });
  }

  public submitSearchForm() {
    // make lists empty
    this._elasticSearchService.productsData.set([]);
    this._elasticSearchService.productsCount.set(0);
    this._elasticSearchService.auctionsData.set([]);
    this._elasticSearchService.auctionsCount.set(0);
    this._elasticSearchService.tendersData.set([]);
    this._elasticSearchService.tendersCount.set(0);
    this._elasticSearchService.businessesData.set([]);
    this._elasticSearchService.businessesCount.set(0);

    // get search term data
    const searchContent = this.searchForm.value.searchTerm;

    // navigate to products route
    this._router.navigate(['/search-results'], {
      queryParams: {
        search: searchContent,
      },
    });
  }
}
